import axios from "axios"
import { useEffect, useState } from "react"
import { getRestApiConfig } from "../../../../api/config"

const PublicHolidaysHandle = () =>
{
    const [yearNum, setYearNum] = useState('')
    const [currentHolidays, setCurrentHolidays] = useState([])

    useEffect(() => { setYearNum(new Date().getFullYear().toString()) }, [])

    useEffect(() =>
    {
        const getPublicHolidays = async () =>
        {
            const restApiConfig = getRestApiConfig()
            const endpointURL = new URL(`api/v1/TimeTerms/PublicHolidays?year=${yearNum}`, restApiConfig.baseUrl).href
            const response = await axios.get(endpointURL, { headers: { ...restApiConfig.authHeader } })
            setCurrentHolidays(response.data)
        }

        getPublicHolidays()
    }, [yearNum])


    return currentHolidays
}

export default PublicHolidaysHandle